import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Embedder from "./Embedder";

// Create a context for global state
const ChatContext = React.createContext();

const App = ({ initObj }) => {
    const [appState, setAppState] = useState(initObj);
    const embedderRef = useRef();

    console.log("APP: initObj:", initObj);

    useEffect(() => {
        if (embedderRef.current?.initialize) {
            embedderRef.current.initialize(appState);
        } else {
            console.error("Failed to initialize Embedder");
        }
    }, [appState]);

    return (
        <ChatContext.Provider value={{ appState, setAppState }}>
            <Embedder ref={embedderRef} />
        </ChatContext.Provider>
    );
};

const renderApp = (containerId, initObj) => {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Container not found: ${containerId}`);
        return;
    }

    ReactDOM.createRoot(container).render(
        <React.StrictMode>
            <App initObj={initObj} />
        </React.StrictMode>
    );
};

const fetchBotInfo = async (apiBaseUrl, botId) => {
    const res = await fetch(`${apiBaseUrl}/api/botinfo/${botId}`);
    if (!res.ok) throw new Error("Bot info not available");
    return res.json();
};

const initialize = async (initObj) => {
    if (!initObj) {
        console.error("No initObj provided");
        return;
    }

    try {
        const apiBaseUrl = window.chattrick?.apiBaseUrl;
        const { styling, chatContext, disclaimerText, privacyPolicy } = await fetchBotInfo(
            apiBaseUrl,
            initObj.botId
        );

        const exObj = await fetchBotInfo(apiBaseUrl, initObj.botId);

        console.log("EXOBJ:", exObj);

        const updatedInitObj = {
            ...initObj,
            apiBaseUrl,
            styling: { ...styling, ...initObj.styling },
            contextSelector: initObj.contextSelector || chatContext.selector,
            context: initObj.context || chatContext.content,
            customDisclaimerText:
                initObj.customDisclaimerText || disclaimerText,
            initialMessage: initObj.initialMessage || "",
            initialMessageIsSilent: initObj.initialMessageIsSilent || false,
            privacyPolicy: initObj.privacyPolicy || privacyPolicy,
            buttonText: exObj.buttonText || "",
            inputPlaceholder: exObj.inputPlaceholder || "",
            aiTypingText: exObj.aiTypingText || ""
        };

        // Special handling for standard-bolag render mode
        if (initObj.renderMode === "standard-bolag") {
            // Look for the container with ID "chattrick"
            const CONTAINER_ID = "chattrick";
            const container = document.getElementById(CONTAINER_ID);

            if (!container) {
                console.error(
                    `Container with ID "${CONTAINER_ID}" not found. StandardBolag chat cannot be rendered.`
                );
                return;
            }

            renderApp(CONTAINER_ID, updatedInitObj);
            return;
        }

        // Handle other render modes as before
        const CONTAINER_ID =
            initObj.renderMode === "static"
                ? initObj.containerId
                : "chattrick-popup-container";

        if (initObj.renderMode !== "static") {
            const chatDiv = document.createElement("div");
            chatDiv.id = CONTAINER_ID;
            document.body.appendChild(chatDiv);
        }

        renderApp(CONTAINER_ID, updatedInitObj);
    } catch (error) {
        console.error("Failed to initialize:", error);
    }
};

const openChat = (message, addToMessageHistory = true) => {
    if (window.chattrickComponent?.openChat) {
        window.chattrickComponent.openChat(message, addToMessageHistory);
    } else {
        console.error("Embedder component not initialized");
    }
};

if (window.chattrick) {
    Object.assign(window.chattrick, { initialize, openChat, _isReady: true });
    window.chattrick.processQueue();
} else {
    console.error("window.chattrick is not defined");
}

export { ChatContext };

// // src/index.js
// import React, { useEffect, useRef } from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import Embedder from './Embedder';

// //console.log("Index.js started");

// let root = null;
// let appComponent = null;

// const App = ({ initObj }) => {
//     //console.log("APP: rendering with initObj:", initObj);
//     const ref = useRef();

//     useEffect(() => {
//         //console.log("APP: mounted");
//         appComponent = ref.current;
//         if (appComponent && typeof appComponent.initialize === 'function') {
//             //console.log("APP: Calling initialize in Embedder");
//             appComponent.initialize(initObj);
//         } else {
//             console.error("APP: Failed to initialize Embedder");
//         }
//     }, [initObj]);

//     return (
//         <Embedder ref={ref} />
//     );
// };

// const renderApp = (containerId, initObj) => {
//     //console.log("APP: Rendering app with containerId:", containerId, "and initObj:", initObj);
//     if (!containerId) {
//         console.warn('APP No containerId provided. Skipping render.');
//         return;
//     }

//     const container = document.getElementById(containerId);
//     if (!container) {
//         console.error(`APP Container not found`, containerId);
//         return;
//     }

//     if (!root) {
//         root = ReactDOM.createRoot(container);
//     }

//     root.render(
//         <React.StrictMode>
//             <App initObj={initObj} />
//         </React.StrictMode>
//     );
// };

// const initialize = async (initObj) => {
//     //console.log("APP: Initialize called in index.js", initObj);

//     if (initObj) {

//         const apiBaseUrl = window.chattrick?.apiBaseUrl;

//         const res = await fetch(`${apiBaseUrl}/api/botinfo/${initObj.botId}`);
//         if (!res.ok) {
//             console.error(`APP Bot info not available`);
//             return;
//         }

//         const { styling, chatContext } = await res.json();

//         initObj.styling = { ...styling, ...initObj.styling };
//         initObj.contextSelector = initObj.contextSelector || chatContext.selector;
//         initObj.context = initObj.context || chatContext.content;

//         if (initObj.renderMode === "static") {
//             const container = document.getElementById(initObj.containerId);
//             if (!container) {
//                 console.error(`APP Container not found`, initObj.containerId);
//                 return;
//             }
//         }

//         switch (initObj.renderMode) {
//             case "static":
//                 renderApp(initObj.containerId, {...initObj, apiBaseUrl: window.chattrick.apiBaseUrl });
//                 break;
//             case "popup":
//             case "sidebar":
//                 const CONTAINER_ID = 'chattrick-popup-container';
//                 const chatDiv = document.createElement('div');
//                 chatDiv.id = CONTAINER_ID;
//                 document.body.appendChild(chatDiv);
//                 renderApp(CONTAINER_ID, {...initObj, apiBaseUrl: window.chattrick.apiBaseUrl, containerId: CONTAINER_ID });
//                 break;
//             default:
//                 console.error('APP Unknown renderMode:', initObj.renderMode);
//         }
//     } else {
//         console.error('APP No initObj provided');
//     }
// };

// const openChat = (message, addToMessageHistory = true) => {
//     //console.log("APP: OpenChat called in index.js", message);
//     if (appComponent && typeof appComponent.openChat === 'function') {
//         appComponent.openChat(message, addToMessageHistory);
//     } else {
//         console.error('APP Embedder component not initialized');
//     }
// };

// // Extend the existing chattrick object
// if (window.chattrick) {
//     //console.log("APP: Extending window.chattrick");
//     window.chattrick.initialize = initialize;
//     window.chattrick.openChat = openChat;
//     window.chattrick._isReady = true;
// } else {
//     console.error('APP window.chattrick is not defined');
// }

// //console.log("APP: Index.js completed");
